import React from "react"
import {
	BrowserRouter as Router,
	Switch,
	Route
} from "react-router-dom"
import PublicWebsiteIndex from "./views/PublicWebsiteIndex"
import TermsAndConditions from "./views/TermsAndConditions"
import PrivacyPolicy from "./views/PrivacyPolicy"

const PublicWebsite:React.FC = () => {
	return (
		<Router>
			<Switch>
				<Route path="/privacy" component={PrivacyPolicy} />
				<Route path="/terms" component={TermsAndConditions} />
				<Route path="/" component={PublicWebsiteIndex} />
			</Switch>
		</Router>
	);
}

export default PublicWebsite;
